<div role='dialog' aria-modal="true" id='sso-login-signup-widget' tabindex="0" [attr.aria-label]="localeTexts?.main?.widgetTitle">
  <button *ngIf='!isMobileView' (click)='closeModal()' class='sso-close-btn'>&times;</button>
  
  <div class='sso-signup-login'>
    <div class='sso-row'>
      <div class='sso-column sso-left-panel'>
        <section class='sso-login-signup-section'>

          <sso-activation
            *ngIf='selectedViewComponent === getViewComponents().ACTIVATION'
            [localeTexts]="localeTexts"
          >
          </sso-activation>
        
          
          <sso-user-details 
            *ngIf='selectedViewComponent === getViewComponents().USER_DETAILS || selectedViewComponent === getViewComponents().WECHAT_USER_DETAILS'
            [isFromWeChat]='selectedViewComponent === getViewComponents().WECHAT_USER_DETAILS'
            (changeViewComponent)="changeViewComponent($event)"
            [localeTexts]="localeTexts"
            [form]='signUpForm'
            (onSignUpError)='onSignUpError($event)'
          >
          </sso-user-details>
          
          
          <forgot-password 
            *ngIf='selectedViewComponent === getViewComponents().FORGOT_PASSWORD'
            (changeViewComponent)="changeViewComponent($event)"
            [localeTexts]="localeTexts"
          >
          </forgot-password>

          <aa-tabs  
            *ngIf='selectedViewComponent === getViewComponents().LOGIN || selectedViewComponent === getViewComponents().SIGNUP' 
            class='sso-tab-nav'
          >
            <aa-tab 
              [title]='localeTexts?.tabs?.login' 
              role="tabpanel" 
              [active]='selectedViewComponent === getViewComponents().LOGIN'
            >
              <sso-login 
                (changeViewComponent)="changeViewComponent($event)"
                [localeTexts]="localeTexts"
              ></sso-login>
            </aa-tab>
            <aa-tab 
              [title]='localeTexts?.tabs?.signup' 
              role="tabpanel" 
              [active]='selectedViewComponent === getViewComponents().SIGNUP'
            >
              <sso-signup
                (changeViewComponent)="changeViewComponent($event)"
                (onSignUpSubmit)="onSignUpSubmit($event)"
                [localeTexts]="localeTexts"
                [errorType]="signUpErrorType"
              ></sso-signup>
            </aa-tab>
          </aa-tabs>
        </section>
        <sso-footer></sso-footer>
      </div>

      <div *ngIf='!isMobileView' class='sso-column sso-right-panel'>
        <sso-sidebar
          [header]='localeTexts?.rightPanel?.headline'
          [body]='localeTexts?.rightPanel?.body'
        >
        </sso-sidebar>
      </div>
    </div>
  </div>

</div>
